import React from 'react';
import MasterclassIndex from '../masterclass/index';

export default function () {
  return <MasterclassIndex noFixedVideo noExitIntent noShare variant="ad" fromEntry="plants" slug="a-l/plants" />;
}
